import { render, staticRenderFns } from "./RequestSellPage.vue?vue&type=template&id=38875960&scoped=true"
import script from "./RequestSellPage.vue?vue&type=script&lang=ts"
export * from "./RequestSellPage.vue?vue&type=script&lang=ts"
import style0 from "./RequestSellPage.vue?vue&type=style&index=0&id=38875960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38875960",
  null
  
)

export default component.exports